import classNames from "classnames/bind";
import styles from "./VideoAI.module.css";
import Table from "./Table";
import { useContext, useEffect, useState } from "react";
import axiosClient from "../../../../services/axiosClient";
import { TracingEventContext } from "../../../../contexts";
import { formatDB, formatDate } from "../../../../utils";
import { Toast } from "../../../../components";
import Filter from "../../../SmartReport/Filter/Filter";
import { SelectBox, SelectBoxItem } from "../../../../components";
import Modal from "../../../SmartReport/Modal/Modal";
import TableCamera from "./TableCamera";
const cx = classNames.bind(styles);

function VideoAI({ listTabBar, tabActive, getTabActive }) {
  const {
    cameraCode,
    isShow,
    listCodeCamera,
    codeAi,
    hourStart,
    setHourStart,
    hourEnd,
    setHourEnd,
    timeStart,
    setTimeStart,
    timeEnd,
    setTimeEnd,
    listCheckApi,
    setCameraCode,
    setName
  } = useContext(TracingEventContext);
  const [pages, setPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [pages2, setPages2] = useState(1);
  const [currentPage2, setCurrentPage2] = useState(1);
  const [isFilterHour, setIsFilterHour] = useState(true);
  const [data, setData] = useState([]);

  const onChangeTimeStart = (data) => {
    setTimeStart(data);
    setCurrentPage(1);
  };
  const onChangeTimeEnd = (data) => {
    setTimeEnd(data);
    setCurrentPage(1);
  };
  const handleOke = (start, end) => {
    setIsFilterHour(true);
    setHourEnd(end);
    setHourStart(start);
    setCurrentPage(1)
  };

  useEffect(() => {
    let date = new Date();
    if (!timeEnd || !timeStart) {
      const time = formatDB(date);
      setTimeStart(time);
      setTimeEnd(time);
    }
  }, []);

  useEffect(() => {
    async function getListPlayBack() {
      const day =
        timeStart && timeEnd
          ? {
              day_start: formatDB(timeEnd),
              day_end: formatDB(timeEnd),
            }
          : {};
      const time =
        isFilterHour && hourEnd && hourStart
          ? {
            hour_start: hourStart,
            hour_end: hourEnd,
            }
          : {};
      if (cameraCode) {
        let ai_service_code = codeAi === "All" ? {}:{ ai_service_code: codeAi} 
        const res = await axiosClient.get("/camAI/get-list-cam-ai/", {
          params: {
            ...ai_service_code,
            camera_code: cameraCode,
            ...day,
            ...time,
            page: currentPage,
            size: 10,
          },
        });
        if (res) {
          setPages(Math.ceil(res.count / 10));
          setData(res.data);
        }
      }
    }
    getListPlayBack();
  }, [
    cameraCode,
    timeEnd,
    timeStart,
    hourStart,
    hourEnd,
    isFilterHour,
    currentPage,
    codeAi,
  ]);
  useEffect(()=>{
    setPages2(Math.ceil(listCheckApi.length/10))
  },[listCheckApi])
  useEffect(()=>{
    const check = listCheckApi.some((item)=>item.camera_code===cameraCode)
    if(!check){
      setData([])
      setCameraCode('')
      setName('')
    }
  },[listCheckApi])
  return (
    <div className={cx("data")}>
      <div id="__notification"></div>
      <div className={cx("filter")}>
        <div style={{ flex: 1, marginTop: 13 }}>
          <label className={cx("label")}>Sự kiện</label>
          <SelectBox
            type="small"
            style={{ paddingTop: 8 }}
            onChange={getTabActive}
            // label="Sự kiện"
          >
            <SelectBoxItem
              label={"Tất cả"}
              value={"All"}
              //   key={index}
            />
            {listTabBar &&
              listTabBar?.map((item, index) => (
                <SelectBoxItem
                  label={item.tabName}
                  value={item.code}
                  key={index}
                />
              ))}
          </SelectBox>
        </div>
        <div style={{ flex: 3 }}>
          <Filter
            onChangeDayEnd={onChangeTimeEnd}
            onChangeDayStart={onChangeTimeStart}
            timeStart={timeStart}
            timeEnd={timeEnd}
            isFilter={isFilterHour}
            onOk={handleOke}
          />
        </div>
      </div>
      <div
        style={{ display: "flex", justifyContent: "space-between", gap: 12 }}
      >
        <TableCamera
          data={listCheckApi}
          getPage={(data) => setCurrentPage2(data)}
          pages={pages2}
          currentPage={currentPage2}
          setPages={setPages2}
          setCurrentPage={setCurrentPage}
        />
        <Table
          data={data}
          getPage={(data) => setCurrentPage(data)}
          pages={pages}
          currentPage={currentPage}
        />
      </div>
      {isShow && <Modal type="tracing" />}
    </div>
  );
}

export default VideoAI;
